import gql from "graphql-tag";

export const PreRequests = gql`
  query GetPreRequests(
    $skip: Int
    $sortField: String
    $sortDirection: String
  ) {
    preRequests(
      skip: $skip
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      items {
        id
        estimatedBudget
        organizationDescription
        projectDescription
        projectName
        createdAt
        status
        request {
          id
        }
      }
      count
    }
  }
`;
